<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="head">
  <h1 *ngIf="isNieuw">Nieuwe medewerker</h1>
  <h1 *ngIf="! isNieuw">{{ record?.orig('naam') }}</h1>
</div>
<div class="content">
  <form #form='ngForm' autocomplete="off">
    @if (record.certificeringmeldingen(); as certificeringmeldingen) {
      @if (certificeringmeldingen.length) {
        <div class="certificeringwaarschuwing">
          <span class="fas fa-exclamation-triangle"></span>
          <div>
            @for (melding of certificeringmeldingen; track $index) {
              <div>{{ melding }}</div>
            }
          </div>
        </div>
      }
    }
    <tabset>
      <tab heading="Basisgegevens">
        <div class="form-row">
          <div class="w-col-lg-4 w-col-md-8">
            <div class="form-group mb-0">
              <label [for]="id('voornaam')">Voornaam</label>
              <input type="text" [id]="id('voornaam')" name="voornaam" autofocus class="form-control" minlength="1"
                     maxlength="38" [disabled]="readonly"
                     [(ngModel)]="record.voornaam" spellcheck="false">
            </div>
          </div>
          <div class="w-col-lg-2 w-col-md-4">
            <div class="form-group mb-0">
              <label [for]="id('tussenvoegsels')">Tussenvoegsels</label>
              <input type="text" [id]="id('tussenvoegsels')" name="tussenvoegsels" autofocus class="form-control"
                     minlength="1" maxlength="28" [disabled]="readonly"
                     [(ngModel)]="record.tussenvoegsels" spellcheck="false">
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group mb-0">
              <label [for]="id('naam')">Achternaam</label>
              <input type="text" [id]="id('achternaam')" name="achternaam" autofocus class="form-control" minlength="1"
                     maxlength="98" required [disabled]="readonly"
                     [(ngModel)]="record.achternaam" spellcheck="false">
            </div>
          </div>
        </div>
        <div class="mb-4"><small>Exact-naam: {{ record.naam }}</small></div>

        <div class="form-row">
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('woonplaats')">Woonplaats</label>
              <input type="text" [id]="id('woonplaats')" name="woonplaats" class="form-control" maxlength="98"
                     [disabled]="readonly" [(ngModel)]="record.woonplaats">
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('telefoonnummer')">Telefoonnummer</label>
              <input type="text" [id]="id('telefoonnummer')" name="telefoonnumer" class="form-control" maxlength="15"
                     [disabled]="readonly"
                     [(ngModel)]="record.telefoonnummer">
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('groep')">Groep</label>
              <select [id]="id('groep')" name="groep" class="form-control" required [disabled]="readonly"
                      [(ngModel)]="record.groep" (change)="record.leverancier_id=null">
                <option *ngFor="let groep of Personeel.PersoneelsGroepen" [ngValue]="groep">{{ groep }}</option>
              </select>
            </div>
          </div>
          <div class="w-col-lg-6" *ngIf="record.groep !== 'Personeel'">
            <div class="form-group">
              <label [for]="id('leverancier')">Leverancier</label>
              <select [id]="id('leverancier')" name="leverancier" class="form-control" required [disabled]="readonly"
                      [(ngModel)]="record.leverancier_id">
                <ng-container *ngFor="let leverancier of lookups['leverancier']">
                  <option [ngValue]="leverancier.id"
                          *ngIf="leverancier.werkmaatschappij_id === record.werkmaatschappij_id && leverancier.leverancierstype === groepNaarLeverancierstype()">{{ leverancier.naam }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('nummer')">Nummer</label>
              <input type="text" [id]="id('nummer')" name="nummer" class="form-control" minlength="1" maxlength="20"
                     required [disabled]="readonly"
                     [(ngModel)]="record.nummer" spellcheck="false">
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('amulnummer')">AMUL-nummer</label>
              <input type="text" [id]="id('amulnummer')" name="amulnummer" class="form-control" minlength="1"
                     maxlength="8"
                     [disabled]="readonly"
                     [(ngModel)]="record.amulnummer" spellcheck="false">
            </div>
          </div>
          <div class="w-col-lg-6" *ngIf="! isNieuw">
            <div class="form-group">
              <label [for]="id('actief')">In te zetten</label>
              <select [id]="id('actief')" name="actief" class="form-control" required [(ngModel)]="record.actief"
                      (change)="actiefGewijzigd()" [disabled]="readonly">
                <option [ngValue]="true">Inzetbaar</option>
                <option [ngValue]="false">Niet inzetbaar</option>
              </select>
              <small class="form-text text-muted">Niet inzetbaar personeel kan niet worden ingepland en wordt op veel
                plekken standaard verborgen.</small>
              <small class="form-text text-muted" *ngIf="(! isNieuw) && record?.orig('actief') && (!record.actief)">Let
                op:
                als een personeelslid op niet inzetbaar wordt ingesteld, stellen we ook in dat hij/zij niet meer kan
                inloggen. Dit kan je eventueel zelf weer wijzigen.</small>
            </div>
          </div>
          <div class="w-col-lg-6">
            <div class="form-group">
              <label [for]="id('einddatum_certificering')">Einddatum raamovereenkomst</label>
              <sihwdatepicker class="form-control" [id]="id('einddatum_certificering')"
                              name="einddatum_certificering" placeholder="dd-mm-jjjj"
                              [(ngModel)]="record.einddatum_certificering" [bsConfig]="datepickerconfig"
                              [disabled]="readonly"
              ></sihwdatepicker>
              <small class="form-text text-muted">De laatste dag waarop de raamovereenkomst geldig is. Leeg =
                geen einddatum.</small>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label [for]="id('opmerkingen')">Opmerkingen</label>
          <textarea class="form-control" [id]="id('opmerkingen')" name="opmerkingen" [disabled]="readonly"
                    [(ngModel)]="record.opmerkingen"></textarea>
        </div>
      </tab>
      <tab heading="Functies">
        <table class="table functietabel">
          <thead>
          <tr>
            <th class="smal"></th>
            <th class="smal"></th>
            <th>Functie</th>
            <th class="smal">Hoofd</th>
            <th class="datum">Einddatum certificering</th>
            @if (!readonly) {
              <th class="smal"></th>
              <th class="smal"></th>
            }
          </tr>
          </thead>
          <tbody>
            @for (pf of record.personeelvast_functie; track pf.trackerId) {
              <tr [class.verwijderd]="pf._tags.verwijderd">
                <td class="text-center">
                  @if (vindFunctie(pf)?.kleur) {
                    <span class="kleur" [style.background-color]="vindFunctie(pf).kleur"></span>
                  }
                </td>
                <td class="text-center">
                  @if (exactWaarschuwing(pf); as waarschuwing) {
                    <span class="fas fa-exclamation-triangle text-warning" [title]="waarschuwing"></span>
                  }
                </td>
                <td class="functienaam" [class.certificering-verlopen]="certificeringVerlopen(pf)"
                    [title]="certificeringVerlopen(pf) ? 'De certificering voor deze functie is verlopen' : ''"
                >{{ vindFunctie(pf)?.naam || '?' }}</td>
                <td class="text-center hoofdfunctie">
                  <span class="fas" [class.fa-check]="pf.hoofdfunctie" [class.fa-times]="! pf.hoofdfunctie"></span>
                </td>
                <td>
                  <sihwdatepicker class="form-control" [id]="id('certificering_' + pf.trackerId)"
                                  [name]="'certificering_' + pf.trackerId" placeholder="dd-mm-jjjj"
                                  [(ngModel)]="pf.einddatum_certificering" [bsConfig]="datepickerconfig"
                                  (ngModelChange)="setDirty()"
                                  [disabled]="readonly || pf._tags.verwijderd"
                  ></sihwdatepicker>
                </td>
                @if (!readonly) {
                  <td class="actie">
                    <span class="hidebijverwijderd fas fa-check text-success" title="Maak hoofdfunctie"
                          (click)="maakHoofdfunctie(pf)"></span>
                  </td>
                  <td class="actie">
                    <span class="hidebijverwijderd fas fa-trash text-danger" title="Verwijder"
                          (click)="verwijderFunctie(pf)"></span>
                    <span class="showbijverwijderd fas fa-undo text-black-50" title="Terugzetten"
                          (click)="verwijderFunctie(pf)"></span>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        <div class="form-group mt-2" *ngIf="! readonly">
          <label for="functies">Voeg functie toe</label>
          <div class="input-group append-space">
            <select class="form-control" id="functies" [(ngModel)]="ux.nieuwefunctie"
                    [ngModelOptions]="{standalone: true}">
              <ng-container *ngFor="let functie of functieLookups">
                <option [ngValue]="functie" *ngIf="kanFunctieToevoegen(functie)">{{ functie.naam }}</option>
              </ng-container>
            </select>
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" [disabled]="! ux.nieuwefunctie"
                      (click)="nieuwefunctie()">Toevoegen
              </button>
            </div>
          </div>
        </div>
      </tab>
      <tab heading="Labels">
        <p>Met labels kan je personeel indelen in het planbord.</p>
        <div class="form-row mb-2">
          @for (label of record.personeel_label; track label) {
            <div class="w-col-md-6">
              <div class="linksrechts label">
                <div>{{ label.label }}</div>
                @if (!readonly) {
                  <div>
                    <span class="fas fa-trash text-danger" title="Verwijder" (click)="verwijderLabel(label)"></span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (!readonly) {
          <div class="form-row">
            <div class="w-col-md-6 mb-2">
              <div class="form-group">
                <label [for]="id('labels')">Voeg een bestaand label toe</label>
                <div class="input-group">
                  <select class="form-control" [id]="id('labels')" [(ngModel)]="ux.nieuwlabelkeuze"
                          [ngModelOptions]="{standalone: true}">
                    @for (label of labels; track $index) {
                      @if (!record.heeftLabel(label)) {
                        <option [ngValue]="label">{{ label }}</option>
                      }
                    }
                  </select>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" [disabled]="! ux.nieuwlabelkeuze" (click)="nieuwLabel(ux.nieuwlabelkeuze)"><span class="fas fa-plus"></span></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-col-md-6 mb-2">
              <div class="form-group">
                <label [for]="id('labelinvoer')">Of: typ een nieuw label</label>
                <div class="input-group">
                  <input type="text" class="form-control" [id]="id('labelinvoer')" [(ngModel)]="ux.nieuwlabelinvoer"
                          [ngModelOptions]="{standalone: true}">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" [disabled]="! ux.nieuwlabelinvoer" (click)="nieuwLabel(ux.nieuwlabelinvoer)"><span class="fas fa-plus"></span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </tab>
      <tab heading="Inloggen">
        <p>Personeel kan inloggen in de mobiele website om hun planning te bekijken en werkbonnen in te dienen.</p>
        <div class="form-row">
          <div class="w-col-md-6">
            <div class="form-group">
              <label [for]="id('inlog_actief')">Inloggen</label>
              <select [id]="id('inlog_actief')" name="inlog_actief" class="form-control" required [disabled]="readonly"
                      [(ngModel)]="record.inlog_actief">
                <option [ngValue]="true">Toestaan</option>
                <option [ngValue]="false">Niet toestaan</option>
              </select>
            </div>
          </div>
          <div class="w-col-md-6">
            <div class="form-group">
              <label [for]="id('email')">E-mail</label>
              <input type="email" class="form-control" [id]="id('email')" name="email" spellcheck="false"
                     [disabled]="readonly"
                     [(ngModel)]="record.email">
              <small class="form-text text-muted">Als dit e-mailadres een geldige Microsoft-account vertegenwoordigt
                (bij
                ATR of daarbuiten), dan accepteren wij een inlog via Microsoft.</small>
            </div>
          </div>
          <div class="w-col-md-6">
            <div class="form-group">
              <label [for]="id('wachtwoord')">Wachtwoord</label>
              <input type="text" [id]="id('wachtwoord')" name="wachtwoord" class="form-control"
                     minlength="6" [disabled]="readonly"
                     [(ngModel)]="record._tags.wachtwoord">
              <small class="form-text text-muted">Vul alleen een wachtwoord in als je het wilt
                wijzigen. Standaard is er geen wachtwoord: alleen inloggen via Microsoft. Minimum lengte: 6
                tekens.</small>
            </div>
          </div>
        </div>
      </tab>
    </tabset>
  </form>
</div>

<div class="foot">
  <div class="buttons" links>
    <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
    <button class="btn btn-danger" (click)="delete()" *ngIf="! readonly && ! isNieuw" [disabled]="! canDelete"
            [attr.title]="canDelete ? 'Verwijder dit personeelslid' : 'Dit personeelslid kan niet verwijderd worden, omdat ernaar wordt verwezen. Wel kan hij/zij inactief gemaakt worden.'">
      Verwijderen
    </button>
  </div>
  <div class="buttons" rechts>
    <button class="btn btn-primary" (click)="save()" *ngIf="! (readonly || shouldReload)"
            [disabled]=" form.invalid || form.pristine">
      Opslaan
    </button>
    <button class="btn btn-warning" (click)="reload()" *ngIf="shouldReload">Herladen (gewijzigd)</button>
  </div>
</div>
